import { Injectable,Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppDetailsService } from '../services/app-details.services';
import { EmitterService } from '../services/emitter.service';
import { Router } from '@angular/router';
import { WINDOW } from '../services/window.service';
import { environment } from '../../environments/environment';
//import { AuthService } from './auth.service';

@Injectable()
export class RouterGuardService   {
 // currentURL_slug;
  constructor(
    private appDetailsService:AppDetailsService,
    private emitterService:EmitterService,
    private router: Router,
    @Inject(WINDOW) private window: Window,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any>{
    return Promise.resolve(this.appDetailsService.getBlockedCountries())
    .then(
      res => {

        return true;
        
        // let val = true;
        // if (res && res["countryCode"] &&  res["countryCode"] === "SE")   {
        //   this.emitterService.broadcastActionNotPermitter("NO_REG_FROM_COUNTRY")
        //   val =  false;
        // }else{
        //   if(environment.trustlyCountries.indexOf(res["countryCode"]) >= 0 ){
        //    // this.currentURL_slug = this.window.location.pathname.substring(3) + window.location.search;
        //    // let params;
        //    // if(window.location.search.length >0){
        //    //  params = JSON.parse('{"' + decodeURI(window.location.search.substring(1).replace(/&/g, "\",\"").replace(/=/g, "\":\"")) + '"}');
        //    // }
        //     this.router.navigate([ localStorage.getItem("langCode") + '/playnow/step1'], { queryParams: route.queryParams });
        //         return false;
        //   }
        // }
        // return val;
      },
        SystemError => { }
    )
      //return false;
  }
}
